import styled from '@emotion/styled';
import { Text } from '@/components/atoms/Text';
import { Checkbox as BaseCheckbox } from '@/components/form/Checkbox';
import { Theme } from '@emotion/react/dist/declarations/src';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 2;
    gap: ${({ theme }) => theme.spacing[4]};
`;

const getAlertColor = (status: 'warning' | 'error' | 'info', theme: Theme) => {
    switch (status) {
        case 'warning':
            return theme.color.yellow200;
        case 'error':
            return theme.color.red200;
        case 'info':
            return theme.color.green200;
    }
};

export const AlertContainer = styled.div<{ status: 'warning' | 'error' | 'info' }>`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[2]};
    padding: ${({ theme }) => theme.spacing[1]};
    background-color: ${({ theme, status }) => getAlertColor(status, theme)}20;
    color: ${({ theme, status }) => getAlertColor(status, theme)};
    p {
        color: ${({ theme, status }) => getAlertColor(status, theme)};
    }
    border-radius: ${({ theme }) => theme.radius.main};
`;

export const ListContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Item = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[1]};
    color: ${({ theme }) => theme.color.grey500};
`;

export const Title = styled(Text)``;

export const Checkbox = styled(BaseCheckbox)`
    margin-bottom: ${({ theme }) => theme.spacing[2]};
`;

export const Link = styled.span`
    color: ${({ theme }) => theme.color.blue200};
    text-decoration: underline;
    cursor: pointer;
    font-size: ${({ theme }) => theme.font.size.normal};
`;
